module.exports = __webpack_public_path__ + "static/media/brennstoffer.5ad5357f.m4a";